import React from 'react';
import * as actions from './Actions';
import Service from '../service/Service';

const service = new Service();
export default function ({ sideBarData, eleRef }) {
    
    return (
        <div className="popUpPersonalised addAns-overlay choose">
           <div className="addAns-popup select_child_popup">
                <div className="section_enter_child_detailsview">
                <div className="close_popup_feeds_all" onClick={()=>{actions.closePopupcommon(eleRef)}}> 
                 <span data-icon-font="C" className="icon"></span>
                </div>
                <div className="child_heading_whether M18_21"> Choose whether you are </div>
                 <div className="child_details_genders">
                    <div className={(eleRef.state.expectedTab==1)?"left_gender_view avitve_parents":"left_gender_view"} onClick={(e)=>actions.expectedProfile(1,eleRef)}> 
                       <div className="expecting_m R14_42"> Expecting Mother</div>
                    </div>
                    <div className={(eleRef.state.expectedTab==2)?"right_gender_view avitve_parents":"right_gender_view"} onClick={(e)=>actions.expectedProfile(2,eleRef)}> 
                       <div className="expecting_m R14_42"> Expecting Father</div>
                    </div>
                  </div>
                    <div className="child_details_profile_form">
                       <form action="#" className="fieldset_details_form">

                         <fieldset>
                           <legend htmlFor="childDueDate">Enter Due Date</legend>
                           <input type="text" placeholder="Enter Due Date" name="childDueDate" id="child_DueDate" className="R14_42" readOnly  onKeyPress={(e) => service.onKeyPressDate(e)} onFocus={(e) => service.onFocusDate(e)} onBlur={(e) => service.onBlurDate(e)} />
                           <span className="R15_21 tap_here"> </span>
                           <div className="fieldset_details_input_common " id="calendar-icon">
                              <img src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/Calender_Icon.png" alt="select due date" title="select due date"/>
                           </div>
                         </fieldset>
                         <div className="child_enter_correct_date R11_red" > </div>

                          <div className="child_details_btn_view mt_bottom15"> 
                          <button className="M15_white" type="button" onClick={actions.OnChoosePopupSubmit}> Submit</button>
                          </div>
                          <div className="child_details_btn_submit"> 
                            <button className="M15_75" type="button" onClick={()=>{actions.closePopupcommon(eleRef)}}> Cancel </button>
                          </div>
                          <div className="check_details_field">
                             
                             <span className="icon select-all checkbox checkAll" data-icon-font="z" id="setpic" value="0" onClick={(e) => { actions.pisTestdone(e) }}>
                             <span className="R13_42 check-text ">Don't prompt me again</span>
                             </span>
                          </div>
                        </form>
                    </div>
              </div>
           </div>
        </div>

)
}
